// extracted by mini-css-extract-plugin
export default {"container":"EditVideo_container__48e5d"};